<label id="question-radio-group-label" class="fst-italic pb-2">
    {{question.label}}
</label>

<div class="d-none d-sm-flex d-md-none d-xl-flex
            py-2 py-sm-4 align-items-end justify-content-center">
    <div class="scale-label text-end ps-0 pe-2">{{possibleAnswers[0]?.label}}</div>
    <div class="px-0 px-sm-3 d-sm-flex justify-content-between align-items-center fs-6 text-secondary w-75 answer-line">
        @for (choice of possibleAnswers; track choice) {
            <label for="answer-{{choice.id}}" class="answer-option py-2 py-sm-0" [ngClass]="{'isChecked': userAnswerId === choice.id}">
                <input id="answer-{{choice.id}}" [value]='choice.id'
                       type="radio" name="answer"
                       [ngModel]="userAnswerId"
                       (ngModelChange)="changeAnswer($event)">
                <div class="custom-checkmark"></div>
                <div class="answer-text-label">{{choice.position}}</div>
            </label>
        }
    </div>
    <div class="ps-2 pe-0 scale-label">{{possibleAnswers[possibleAnswers.length-1]?.label}}</div>
</div>

<div class="d-sm-none d-md-block d-xl-none py-2">
    <div class="px-0 px-sm-3 fs-6 text-secondary w-75 mx-auto answer-line">
        @for (choice of possibleAnswersReverse; track choice) {
            <label for="answer-{{choice.id}}" class="answer-option py-2" [ngClass]="{'isChecked': userAnswerId === choice.id}">
                <input id="answer-{{choice.id}}" [value]='choice.id'
                       type="radio" name="answer"
                       [ngModel]="userAnswerId"
                       (ngModelChange)="changeAnswer($event)">
                <div class="custom-checkmark"></div>
                <div class="d-sm-none d-md-block d-xl-none answer-text-label ps-1">{{choice.label}}</div>
            </label>
        }
    </div>
</div>